// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module('frontDoorPage')
  .directive('giSelfLinkClass', ($window, siteMap) => ({
    restrict: 'A',

    link(scope, element, attrs) {
      if (
        siteMap.cleanRelativePath(attrs['href']) === $window.location.pathname
      ) {
        return $(element).addClass(attrs['giSelfLinkClass']);
      }
    },
  }));
